// extracted by mini-css-extract-plugin
export default {"button":"styles_button__IR83W","disabled":"styles_disabled__N8fAu"};